import { useState } from 'react';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '../../../../components/Shared/Loader/Loading';
import NeatixModal from '../../../../components/Modal/NeatixModal';
// import CreateAccount from './CreateAccount';
import useGetUpdateCostList from '@hooks/INV/InvUpdataCost/useGetUpdateCostList';
import NtxTable from '@components/DataTable/NtxTable';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const Index = () => {
  const { HasPermission } = usePermissions();
  const Navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [show, setShow] = useState(false);

  const { UpdateCostList: data, loading: loading2 } = useGetUpdateCostList();

  // فلترة البيانات بناءً على البحث، ونوع الحركة

  const columns = [
    { title: t('Number'), key: 'num' },
    { title: t('Date'), key: 'date' },
    { title: t('TransType'), key: 'type' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = data?.slice()?.map((item: any) => {
    let rowClass;

    return {
      num: item.code,
      date: item.transactionDate?.split('T')[0],
      type: item.transactionTypeName,
      action: (
        <div className='btn-group'>
          {HasPermission('INVViewUpdateCostDetails') && (
            <button
              type='button'
              className='btn btn-sm btn-outline-theme'
              onClick={() => Navigate(`${item.id}/UpdateUpdateCost`)}
            >
              <i className='far fa-lg me-2 fa-fw fa-edit'></i>
              {t('Button.Edit')}
            </button>
          )}
        </div>
      )
    };
  });

  //________________________________
  const BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome'
    },
    {
      name: 'UpdateCost',
      link: null
    }
  ];

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName='UpdateCost' />

        <div className='ms-auto'>
          {HasPermission('INVAddUpdateCost') && (
            <Link to='AddUpdateCost' className='btn me-1 btn-theme'>
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('Add UpdateCost')}
            </Link>
          )}
        </div>
      </div>

      <Card>
        {/* <Loading loading={loading} error={error}> */}
        <CardBody>
          <NtxTable
            data={tableData || []}
            columns={columns}
            dataPerPage={10}
            theadClass=''
            tableClass='table text-nowrap table-hover '
            enableSearch
            showRecordsSelector
          />
        </CardBody>
        {/* </Loading> */}
      </Card>

      <NeatixModal show={show} setShow={setShow} size='md' showHeader={false} bodyClassName='p-0'>
        <Card>
          <CardBody>{/* <CreateAccount /> */}</CardBody>
        </Card>
      </NeatixModal>
    </div>
  );
};

export default Index;
